import React, { Component } from 'react'
import { Redirect } from 'react-router-dom'
import Auth from '../services/Auth';
import axios from "axios/index";

const auth = new Auth();

class Logout extends Component {

    componentDidMount() {
        axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";
        axios.defaults.xsrfCookieName = "csrftoken";
        const url = process.env.REACT_APP_API_SERVER+'/logout';
        axios.get(url)
            .then(res => {
                this.handleLogout();
            });
        }

    handleLogout() {
        auth.endSession();
    }

    render() {
        this.handleLogout();
        if (!auth.isAuthenticated()) {
            return <Redirect to="/login" />
        }
    }
}

export default Logout



// WEBPACK FOOTER //
// ./src/pages/Logout.js